import { getCompanyInfo } from '@api/directOffers';
import { ofType } from 'redux-observable';
import {
  GET_COMPANY_INFO,
  GET_COMPANY_INFO_ERROR,
  SET_COMPANY_INFO,
} from '@actions/company';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';
import { of } from 'rxjs';
import { COMPANY_SYNDICATION_STATES } from '@reducers/company';
import { get } from 'lodash';

export const getCompanyInformation = action$ =>
  action$.pipe(
    ofType(GET_COMPANY_INFO),
    switchMap(action => {
      const { baseUrl, companyKey } = action.payload;
      return fromPromise(getCompanyInfo(baseUrl, companyKey)).pipe(
        map(response => {
          const payload = {
            // isWhiteListed,
            name: get(response, ['data', 'name'], ''),
            logo: get(response, ['data', 'custom_logo'], ''),
            overrideEmail: get(
              response,
              ['data', 'quickview_override_email'],
              '',
            ),
            overridePhone: get(
              response,
              ['data', 'quickview_override_phone'],
              '',
            ),
            syndicationState:
              get(response, ['data', 'parade_public_loadboard_enabled']) ===
              true
                ? COMPANY_SYNDICATION_STATES.SUPPORTED
                : COMPANY_SYNDICATION_STATES.NO_SUPPORT,
          };
          return { type: SET_COMPANY_INFO, payload };
        }),
        catchError(err => {
          return of({ type: GET_COMPANY_INFO_ERROR, payload: err });
        }),
      );
    }),
  );
